export default "__VITE_ASSET__CzTwkdkK__"